import React from "react";
import useSPPosition from "../../hooks/useSPPosition";
import useSPUndo from "../../hooks/useSPUndo";
import SPPositionFormGroup from "./SPPositionFormGroup";
import SearchField from "../SearchField/SearchField";
import { handleProductSelect, addEdits, handleInputSelect } from "./utils/inputhandlers";

const PositionsSPGeneral = ({ ignoreEnter, clearfield }) => {
  // load context values
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, undoListSP, setEditingFieldSP } = useSPUndo();

  return (
    // <div className='addposUSA-1'>
    <div>
      {/* Position ID and Date */}
      <SPPositionFormGroup readOnly={true} labelname={"PosID"} inputname={"SPposID"} />
      <SPPositionFormGroup readOnly={true} type={"date"} labelname={"Pos Date"} inputname={"posDate"} />
      {/* Purchase From Radio Buttons */}
      <fieldset>
        <legend>Purchase From:</legend>
        <div className='purchasefrom'>
          <div className='purchasefromform-group'>
            <label>
              <input
                name='purchaseFrom'
                type='radio'
                checked={SPposition && SPposition.purchaseFrom === 1 ? true : false}
                onClick={(e) => {
                  setSPposition((prev) => ({ ...prev, ["purchaseFrom"]: 1 }));
                  setSPpositionData((prev) => ({ ...prev, ["purchaseFrom"]: 1 }));
                  positionEditsSP.current.push({
                    editID: editIDSP,
                    name: e.target.name,
                    value: 1,
                    num: 1,
                    figuretype: "radio",
                  });
                  setEditIDSP((prev) => prev + 1);
                  setEditingFieldSP(false);
                  undoListSP.current = [];
                }}
                value={SPposition.purchaseFrom}
                required
              />
              Supplier
            </label>
          </div>
          <div className='purchasefromform-group'>
            <label>
              <input
                name='purchaseFrom'
                type='radio'
                checked={SPposition && SPposition.purchaseFrom === 2 ? true : false}
                onClick={(e) => {
                  setSPposition((prev) => ({ ...prev, ["purchaseFrom"]: 2 }));
                  setSPpositionData((prev) => ({ ...prev, ["purchaseFrom"]: 2 }));
                  positionEditsSP.current.push({
                    editID: editIDSP,
                    name: e.target.name,
                    value: 2,
                    num: 2,
                    figuretype: "radio",
                  });
                  setEditIDSP((prev) => prev + 1);
                  setEditingFieldSP(false);
                  undoListSP.current = [];
                }}
                value={SPposition.purchaseFrom}
                required
              />
              Intercompany
            </label>
          </div>
        </div>
      </fieldset>
      {/* Identifiers (WGPUS) */}
      <fieldset>
        <legend>Identifiers:</legend>
        <SPPositionFormGroup labelname={"WGPSP"} inputname={"WGP"} inputtype={"integer"} cplaceholder={"WGPSP..."} />
      </fieldset>
      {/* General Information (Product, Supplier, Buyer) */}
      <fieldset>
        <legend>General:</legend>
        <div className='form-group'>
          <label>Product:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/positions/getprodsupplier'
            value={SPposition?.product || ""}
            valueName='product'
            secondaryValueName='supplier'
            valueID='productID'
            style={{ width: "90%" }}
            customplaceholder='Select Product'
            onItemSelect={(item) => {
              handleProductSelect(
                item,
                setSPposition,
                setSPpositionData,
                positionEditsSP,
                addEdits,
                editIDSP,
                setEditIDSP,
                undoListSP
              );
            }}
            clearfield={clearfield}
          />
        </div>
        <div className='form-group'>
          <label>Supplier:</label>
          <input
            readOnly
            placeholder='Supplier...'
            onKeyDown={ignoreEnter}
            name={"supplierID"}
            value={SPposition?.supplier || ""}
          />
        </div>
        <div className='form-group'>
          <label>Buyer:</label>
          <SearchField
            autoComplete='off'
            required={true}
            searchURL='/api/positions/getbuyers'
            value={SPposition?.buyer || ""}
            valueName='buyer'
            valueID='buyerID'
            style={{ width: "90%" }}
            customplaceholder='Select Buyer'
            onItemSelect={(item) => {
              handleInputSelect(
                item,
                positionEditsSP,
                editIDSP,
                setEditIDSP,
                setSPposition,
                setSPpositionData,
                addEdits,
                undoListSP,
                "buyer",
                "buyer"
              );
            }}
            clearfield={clearfield}
          />
        </div>
      </fieldset>
    </div>
  );
};

export default PositionsSPGeneral;
